
import { Label } from "@/components/ui/label";
import { FormData } from "./types";

interface Props {
  formData: FormData;
  setFormData: (data: FormData) => void;
}

const EditUserVerifiedCheckbox = ({ formData, setFormData }: Props) => (
  <div className="flex items-center space-x-2">
    <input
      type="checkbox"
      id="verified"
      checked={formData.verified}
      onChange={(e) => setFormData({ ...formData, verified: e.target.checked })}
      className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
    />
    <Label htmlFor="verified">Verified User</Label>
  </div>
);

export default EditUserVerifiedCheckbox;
